<template>
  <div class="vue-html2pdf">
    <div
      ref="pdfContent"
      class="pdf-export-container"
      :style="contentStyle"
    >
      <slot name="pdf-content"></slot>
    </div>
  </div>
</template>

<script>
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

export default {
  name: 'HtmlToPdf',
  props: {
    showLayout: {
      type: Boolean,
      default: false,
    },
    enableDownload: {
      type: Boolean,
      default: true,
    },
    filename: {
      type: String,
      default: 'document',
    },
    pdfQuality: {
      type: Number,
      default: 2,
    },
    pdfFormat: {
      type: String,
      default: 'a4',
    },
    pdfOrientation: {
      type: String,
      default: 'portrait',
    },
    pdfContentWidth: {
      type: String,
      default: '100%',
    },
  },
  computed: {
    contentStyle() {
      return {
        left: this.showLayout ? 'initial' : '-10000px',
        position: this.showLayout ? 'initial' : 'fixed',
        top: this.showLayout ? 'initial' : '0',
        width: this.pdfContentWidth,
      };
    },
  },
  methods: {
    sanitizeFilename(filename) {
      if (filename && /^[a-zA-Z0-9_-]+$/.test(filename)) {
        return filename;
      }
      return 'document';
    },
    async generatePdf() {
      try {
        const element = this.$refs.pdfContent;
        const canvas = await html2canvas(element, {
          backgroundColor: '#ffffff',
          scale: this.pdfQuality,
          useCORS: true,
        });
        const pdf = new jsPDF({
          orientation: this.pdfOrientation,
          unit: 'pt',
          format: this.pdfFormat,
        });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgHeight = (canvas.height * pageWidth) / canvas.width;
        const imgData = canvas.toDataURL('image/jpeg', 1);

        let heightLeft = imgHeight;
        let position = 0;

        pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, imgHeight);
        heightLeft -= pageHeight;

        while (heightLeft > 0) {
          position = heightLeft - imgHeight;
          pdf.addPage(this.pdfFormat, this.pdfOrientation);
          pdf.addImage(imgData, 'JPEG', 0, position, pageWidth, imgHeight);
          heightLeft -= pageHeight;
        }

        if (this.enableDownload) {
          pdf.save(`${this.sanitizeFilename(this.filename)}.pdf`);
        }

        return pdf;
      } catch (error) {
        if (this.$danger) {
          this.$danger("An error occurred while generating the PDF.");
        }
      }
    },
  },
};
</script>
